import AuthService from "./AuthService";

export default class ApiService {
  static getAiModel = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/ai_models/${uuid}`);
  };

  static getAiModels = async () => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/ai_models`);
  };

  static getAiModelsForProject = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/projects/${uuid}/ai_models`);
  };

  static getInference = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/inferences/${uuid}`);
  };

  static getInferencesForProject = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/projects/${uuid}/inferences`);
  };

  static getInferenceUrl = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/inferences/${uuid}/url`);
  };

  static getOrganization = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/organizations/${uuid}`);
  };

  static getOrganizations = async () => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/organizations`);
  };

  static getOrganizationUsers = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/organizations/${uuid}/users`);
  };

  static getOrganizationAiModels = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/organizations/${uuid}/ai_models`);
  };

  static getOrganizationProjects = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/organizations/${uuid}/projects`);
  };

  static getProject = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/projects/${uuid}`);
  };

  static getProjects = async () => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/projects`);
  };

  static getSourcePerformancesForProject = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/projects/${uuid}/source_performances`);
  };

  static getUser = async (uuid) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/users/${uuid}`);
  };

  static getUsers = async () => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/users`);
  };

  // TODO: philip-nash combine this with getUser above
  static getUserByEmail = async (email) => {
    return await AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/users/email/${email}`);
  };
}
